import LeaderItem from './LeaderItem';

export default LeaderItem;
